



import React, { useState, useEffect, useRef } from "react";
import { Form, Badge } from "react-bootstrap";

export default function ColorVariantSelector({
  popup,
  setPopup,
  availableColors = [],
}) {
  const [showColorDropdown, setShowColorDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setShowColorDropdown((prev) => !prev);
  };

  const handleColorChange = (color) => {
    // ✅ only one color at a time
    setPopup({ ...popup, colorVariant: color });
    setShowColorDropdown(false); // auto close after selecting
  };

  const clearColors = () => {
    setPopup({ ...popup, colorVariant: "" });
  };

  useEffect(() => {
    if (popup?.colorVariant && typeof popup.colorVariant !== "string") {
      // if stored as array before → take first element or empty
      if (Array.isArray(popup.colorVariant)) {
        setPopup((prev) => ({
          ...prev,
          colorVariant: prev.colorVariant[0] || "",
        }));
      } else {
        setPopup((prev) => ({ ...prev, colorVariant: "" }));
      }
    }
  }, [popup?.colorVariant, setPopup]);

  return (
    <Form.Group className="col-md-6 mb-3" ref={dropdownRef}>
      <Form.Label>Color Variant</Form.Label>
      <div className="position-relative">
        {/* ✅ input-like clickable div */}
        <div
          className="form-control d-flex flex-wrap align-items-center"
          onClick={toggleDropdown}
          style={{ cursor: "pointer", minHeight: "38px" }}
        >
          {popup.colorVariant ? (
            <Badge
              pill
              bg="secondary"
              className="me-1 mb-1"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                clearColors();
              }}
            >
              {popup.colorVariant} ✕
            </Badge>
          ) : (
            <span className="text-muted">Select Color</span>
          )}
          <span className="ms-auto dropdown-toggle" />
        </div>

        {showColorDropdown && (
          <div
            className="border rounded p-2 position-absolute bg-white shadow"
            style={{ zIndex: 10, width: "100%" }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <div
              onClick={clearColors}
              style={{
                cursor: "pointer",
                fontWeight: "bold",
                color: "#dc3545",
                marginBottom: "8px",
              }}
            >
              Clear Selection
            </div>

            {availableColors.map((color) => (
              <Form.Check
                key={color}
                type="radio"   // ✅ radio for single selection
                id={`color-${color}`}
                name="colorVariant"
                label={color}
                checked={popup.colorVariant === color}
                onChange={() => handleColorChange(color)}
              />
            ))}
          </div>
        )}
      </div>

      {/* ✅ Hidden input to always submit a string */}
      <input
        type="hidden"
        name="colorVariant"
        value={popup.colorVariant || ""}
      />
    </Form.Group>
  );
}
